import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { FaWhatsappSquare } from "react-icons/fa"

const getData = graphql`
  {
    info: site {
      siteMetadata {
        contact
      }
    }
  }
`

export default function stickybottom() {
  return (
    <StaticQuery
      query={getData}
      render={data => {
        const contact = data.info.siteMetadata.contact
        return (
          <nav className="navbar fixed-bottom navbar-light bg-warning">
            <div className="d-flex w-100 align-items-center">
              <div className="d-flex">
                <div>
                  <a
                    className="navbar-brand"
                    href={contact}
                    aria-label="Chat with 918Kiss support on WhatsApp"
                  >
                    <FaWhatsappSquare className="icon-whatsapp" />
                  </a>
                </div>
                <div className="pt-1">
                  <h6>
                    <a href={contact} className="text-dark">
                      How can we help you? Contact Us Now!
                    </a>
                  </h6>
                </div>
              </div>
            </div>
          </nav>
        )
      }}
    />
  )
}
